// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

const vallhebronTheme = {
  dark: false,
  colors: {
    background: '#F8F9FA',
    surface: '#FFFFFF',
    primary: '#004eb3',
    'primary-darken-1': '#00335d',
    secondary: '#333333',
    'secondary-darken-1': '#D24520',
    error: '#B00020',
    info: '#e3e4e6',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
}


export default createVuetify({
  theme: {
    defaultTheme: 'vallhebronTheme',
    themes: {
      vallhebronTheme,
    },
  },
})